module.exports = __webpack_public_path__ + "img/co-branding-logo-dominoes.fa366ab4.png";